import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "q-mb-2 q-mt-2 q-pb-2 q-ps-5 q-fs-5 q-text-center q-text-muted get-the-look__gtl-title" }

import {PropType} from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'GetTheLookHeader',
  props: {
  useAsSeparate: {
    type: Boolean as PropType<boolean>,
    default: true
  }
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("h4", _hoisted_1, _toDisplayString(__props.useAsSeparate ? 'Dobierz swoją stylizację:' : 'Twoje stylizacje:'), 1))
}
}

})